export default __webpack_public_path__ + "images/b94cf252d63dc4aadab6157d0920150f.svg";